import styled, {css} from 'styled-components';

export type FieldsGroupVariant = 'default' | 'airbnb';

export const Fields = styled.div<{$centered?: boolean; $variant?: FieldsGroupVariant}>`
  display: grid;
  align-self: stretch;
  gap: var(--form-input-gap, 8px);

  ${({$centered}) =>
    $centered &&
    css`
      justify-items: center;
    `}
`;

export const GroupTitle = styled.div<{$variant?: FieldsGroupVariant}>`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  font-weight: 600;
  font-size: 16px;
  text-align: start;
  color: var(--form-section-title-color, #222222);

  grid-column: 1 / -1;
  align-self: stretch;
  justify-self: stretch;

  &:not(:first-child) {
    margin-top: 24px;
  }

  ${({$variant}) =>
    $variant === 'airbnb'
      ? css`
          line-height: 20px;
          padding-block: 0;
          border-bottom: none;
          margin-bottom: var(--form-label-input-gap, 12px);
        `
      : css`
          padding-bottom: 8px;
          border-bottom: 1px solid #dee2db;
          margin-bottom: 24px;
        `}
`;
